// frontend/src/pages/teacher/AssignmentSubmissionsPage.js (فایل جدید)

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import axiosInstance from '../../modules/api';
import { FaSpinner, FaArrowLeft, FaCheckCircle, FaPen, FaTasks, FaUserGraduate } from 'react-icons/fa';
import GradeSubmissionModal from './GradeSubmissionModal'; // مودال نمره‌دهی

// کامپوننت آواتار
const Avatar = ({ name }) => {
    const initial = name ? name.charAt(0) : '?';
    return <div className="avatar">{initial}</div>;
};

const AssignmentSubmissionsPage = () => {
    const { assignmentId } = useParams();
    const [submissions, setSubmissions] = useState([]);
    const [assignmentTitle, setAssignmentTitle] = useState('...');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // State برای مودال
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedSubmission, setSelectedSubmission] = useState(null);

    // تابع useCallback برای جلوگیری از re-render های غیرضروری
    const fetchSubmissions = useCallback(async () => {
        setLoading(true);
        try {
            // دریافت لیست پاسخ‌ها
            const response = await axiosInstance.get(`/core/teacher/assignments/${assignmentId}/submissions/`);
            setSubmissions(response.data);

            // دریافت عنوان تکلیف (از اولین پاسخ یا API جداگانه)
            if (response.data.length > 0) {
                setAssignmentTitle(response.data[0].assignment_title);
            } else {
                // اگر پاسخی نبود، عنوان را جداگانه می‌گیریم (چون صفحه خالی می‌ماند)
                const assignResponse = await axiosInstance.get(`/core/assignments/${assignmentId}/`);
                setAssignmentTitle(assignResponse.data.title);
            }
        } catch (err) {
            console.error("Error fetching submissions:", err);
            setError(err.response?.data?.detail || "خطا در دریافت لیست پاسخ‌ها.");
        } finally {
            setLoading(false);
        }
    }, [assignmentId]);

    useEffect(() => {
        fetchSubmissions();
    }, [fetchSubmissions]);

    // باز کردن مودال برای نمره‌دهی
    const handleOpenGradeModal = (submission) => {
        setSelectedSubmission(submission);
        setIsModalOpen(true);
    };

    // پس از نمره‌دهی، مودال بسته شده و لیست رفرش می‌شود
    const handleGraded = () => {
        setIsModalOpen(false);
        setSelectedSubmission(null);
        fetchSubmissions(); // رفرش کردن لیست
    };

    const renderTableBody = () => {
        if (loading) {
            return <tr><td colSpan="4" className="text-center"><FaSpinner className="spinner text-2xl" /></td></tr>;
        }
        if (error) {
            return <tr><td colSpan="4" className="alert alert-danger text-center">{error}</td></tr>;
        }
        if (submissions.length === 0) {
            return <tr><td colSpan="4" className="text-center p-5">هنوز هیچ دانش‌آموزی پاسخی ارسال نکرده است.</td></tr>;
        }

        return submissions.map(sub => (
            <tr key={sub.id}>
                <td>
                    <div className="user-cell">
                        <Avatar name={sub.student_info?.full_name || sub.student_info?.username} />
                        <span>{sub.student_info?.full_name || sub.student_info?.username}</span>
                    </div>
                </td>
                <td>{new Date(sub.submitted_at).toLocaleString('fa-IR')}</td>
                <td className="text-center">
                    {sub.grade !== null ? (
                        <span className="font-bold text-lg text-green-400">{sub.grade}</span>
                    ) : (
                        <span className="text-yellow-500">نمره داده نشده</span>
                    )}
                </td>
                <td>
                    <button 
                        className="button button-primary"
                        onClick={() => handleOpenGradeModal(sub)}
                    >
                        <FaPen /> {sub.grade !== null ? 'ویرایش نمره' : 'نمره‌دهی'}
                    </button>
                </td>
            </tr>
        ));
    };

    return (
        <>
            <GradeSubmissionModal 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                submission={selectedSubmission}
                onGraded={handleGraded}
            />

            <div className="page-container" style={{maxWidth: '1000px'}}>
                <Link to="/teacher/assignments" className="button button-secondary mb-6 inline-flex items-center">
                    <FaArrowLeft className="ml-2" /> بازگشت به لیست تکالیف
                </Link>

                <div className="page-header" style={{paddingBottom: '10px', marginBottom: '20px'}}>
                    <div>
                        <h1 className="flex items-center gap-3"><FaTasks /> {assignmentTitle}</h1>
                        <p>لیست پاسخ‌های ارسال شده توسط دانش‌آموزان.</p>
                    </div>
                </div>
                
                <div className="data-table-container">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th><FaUserGraduate /> دانش‌آموز</th>
                                <th>تاریخ ارسال</th>
                                <th>نمره (از 20)</th>
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderTableBody()}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default AssignmentSubmissionsPage;